import Button from "@mui/material/Button";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

type ClearChatHistoryDialogProps = {
  dialogOpen: boolean;
  handleDialogClose: () => void;
  handleClearChat: () => void;
};

export const ClearChatHistoryDialog = ({
  dialogOpen,
  handleDialogClose,
  handleClearChat,
}: ClearChatHistoryDialogProps) => {
  return (
    <Dialog open={dialogOpen} onClose={handleDialogClose}>
      <DialogTitle>Clear Chat History</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure you want to clear chat history?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDialogClose}>Cancel</Button>
        <Button onClick={handleClearChat} autoFocus>
          Clear Chat
        </Button>
      </DialogActions>
    </Dialog>
  );
};
